import { useState } from "react";
import { Link } from "react-router-dom";
import { CaretDown, CaretUp, Table } from "@phosphor-icons/react";
import { UploadInvoicePanel } from "@/components/admin/requests/UploadInvoicePanel";
import { RequestsPipeline } from "@/components/admin/requests/RequestsPipeline";

/** One home for every invoice: customer submissions from the public site and spreadsheet uploads. */
export default function Invoices() {
  const [showUpload, setShowUpload] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div className="p-6 max-w-6xl space-y-5" data-testid="invoices-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-[10px] font-black tracking-[0.25em] text-gray-500">BRICKSOURCE · OFFERS4BRICKS</div>
          <h1 className="font-head text-3xl font-black tracking-tight">Invoices</h1>
          <p className="font-mono text-xs text-gray-600 mt-1">Every deal in one place — submissions from the public site and spreadsheets you upload — with the fulfilment checklist for each.</p>
        </div>
        <div className="flex items-center gap-3">
          <Link to="/deals/table" className="font-mono text-[11px] text-gray-500 hover:text-black inline-flex items-center gap-1" data-testid="deals-legacy-link"><Table size={12} /> Legacy row table</Link>
          <button onClick={() => setShowUpload(v => !v)} className="h-8 px-3 inline-flex items-center gap-1 rounded-sm border border-black font-mono text-xs hover:bg-black hover:text-white" data-testid="invoices-toggle-upload">
            {showUpload ? <CaretUp size={12} /> : <CaretDown size={12} />} {showUpload ? "Hide upload" : "Upload spreadsheet"}
          </button>
        </div>
      </div>
      {showUpload && <UploadInvoicePanel onUploaded={() => setReloadKey(k => k + 1)} />}
      <RequestsPipeline reloadKey={reloadKey} />
    </div>
  );
}
